import { RefObject } from 'react';

import { getColumnWidths } from './_utils';
import { processColumn } from './processColumn';
import { processColumnGroup } from './processColumnGroup';
import {
  ColumnProps,
  GroupedColumnProps,
  isColumnsGroup,
  TableApi,
  NormalizedTableProps,
} from '../../../types';
import { applyColumnSettings } from '../../../utils/applyColumnSettings';

type InitializeColumnsArgs = {
  tableApiRef: RefObject<TableApi>;
  groupedColumnsProps: GroupedColumnProps[];
  containerWidth?: number;
  tableProps: NormalizedTableProps;
};

export const initializeColumns = ({
  tableApiRef,
  groupedColumnsProps,
  containerWidth,
  tableProps,
}: InitializeColumnsArgs) => {
  const propsWithSettingsApplied = applyColumnSettings({
    groupedColumnsProps,
    ...tableApiRef.current.state.columnSettings,
  });

  const columnsProps: ColumnProps[] = [];
  for (const props of propsWithSettingsApplied) {
    if (isColumnsGroup(props)) {
      columnsProps.push(...props.columns);
    } else {
      columnsProps.push(props);
    }
  }

  const { columnWidths, tableWidth } = getColumnWidths(
    columnsProps,
    containerWidth,
    tableApiRef.current.state.columnSettings
  );

  tableApiRef.current.columnsInfo = {
    columnsProps,
    groupedColumnsProps,
    groupModels: [],
    columnModels: [],
    tableWidth,
    columnStyles: {},
    columnWidths,
    lockedColumnsWidth: 0,
    scrollableColumnsWidth: 0,
    hasFooter: false,
  };

  for (const column of propsWithSettingsApplied) {
    if (isColumnsGroup(column)) {
      processColumnGroup({
        groupProps: column,
        info: tableApiRef.current.columnsInfo,
        tableProps,
      });
    } else {
      processColumn({
        columnProps: column,
        info: tableApiRef.current.columnsInfo,
        tableProps,
      });
    }
  }
};
